import {
  get,
  put,
  post,
  del,
  default as com
} from '@/common/api'

let api = {
  /** ****************** 国医大师 ****************** **/
  queryNpOrder: (para) => {
    return get('/api/op/np/order', para)
  },
  saveNpOrder: (para) => {
    return put(`/api/op/np/order/${para.id}`, para)
  },
  rejectedNpOrder: (para) => {
    return put(`/api/op/np/order/rejected`, para)
  },
  passNpOrder: (para) => {
    return put(`/api/op/np/order/pass`, para)
  },
  getRegPeriods: (para) => {
    return get(`/api/op/regStatistic/periodList`, para)
  },
}
export default api
